module.exports = __webpack_public_path__ + "img/qrcode.3797b136.png";